import { render, staticRenderFns } from "./MoveContainer.vue?vue&type=template&id=86e559e8&"
import script from "./MoveContainer.vue?vue&type=script&lang=js&"
export * from "./MoveContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports